module.exports = __webpack_public_path__ + "static/media/alternate-jz-menu-logo.e6fe4d0c.svg";